import { render, staticRenderFns } from "./PaymentScheduleDetailsBulk.vue?vue&type=template&id=2863fb96&scoped=true&"
import script from "./PaymentScheduleDetailsBulk.vue?vue&type=script&lang=js&"
export * from "./PaymentScheduleDetailsBulk.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScheduleDetailsBulk.vue?vue&type=style&index=0&id=2863fb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863fb96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2863fb96')) {
      api.createRecord('2863fb96', component.options)
    } else {
      api.reload('2863fb96', component.options)
    }
    module.hot.accept("./PaymentScheduleDetailsBulk.vue?vue&type=template&id=2863fb96&scoped=true&", function () {
      api.rerender('2863fb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/payment-schedules/PaymentScheduleDetailsBulk.vue"
export default component.exports